import { useCallback } from "react";
import FilterIcon from "../../../../icons/FilterIcon";
import SearchIcon from "../../../../icons/SearchIcon";
import DownloadIcon from "@mui/icons-material/Download";
import Button from "../../../../toolkit/ButtonV1";
import FormControl from "../../../../components/FormControl";

import React, { useMemo, useState } from "react";
import _ from "lodash";
import { Divider, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";
import { Card, Grid, Box } from "@mui/material";
import { useEffect } from "react";
import PlusIcon from "../../../../icons/PlusIcon";
import Dialog from "@mui/material/Dialog";
import Adduser from "./Adduser";
import axios from "../../../../utils/fvAxios";
import fileDownload from "js-file-download";
import ExportToExcel from "../../../../utils/ExportToExcel";
import { getOrgType, HasPermissions, HasScreenPermissions } from "../../../../utils/Token";
import INFO from "../../../../pages/commom/RouteUrlInfo.json";
import PER from "../../../../utils/Enums.json";


const searchDebounceDelay = 1000;

const headers = [
  { id: "name", text: "Name", changeActualData: false },
   {id: "orgName", text: "Company Name", changeActualData: false},
  { id: "organizationType", text: "Organization Type", changeActualData: false },
  {
    id: "userStatus",
    text: "Status",
    changeActualData: true,
    changedData: [{ true: "Active", false: "InActive" }],
  },
  { id: "email", text: "Email Address", changeActualData: false },
  { id: "userRoles", text: "Assigned Roles", changeActualData: false },
  { id: "lastLoginDate", text: "Last Login Date", changeActualData: false }
];
export default function UsersCollectionControls({
  searchStr: parentSearchStr,
  setSearchStr: parentSetSearchStr,

  searchStr2: parentSearchStr2,
  setSearchStr2: parentSetSearchStr2,
  searchStr3: parentSearchStr3,
  setSearchStr3: parentSetSearchStr3,

  viewType,
  toggleViewType,
  openSlidingPopup,
  largeScreen,
  setClientId,
  clientId,
  allClients,
  onUserSearchClick,
  downloadUrl,
  fileName,
  sheetName
}) {
  const [searchStr, setSearchStr] = useState(parentSearchStr);
  const [searchStr2, setSearchStr2] = useState(parentSearchStr2);
  const [searchStr3, setSearchStr3] = useState(parentSearchStr3);
  const [open, setOpen] = React.useState(false);

  const debouncedSearchQueryHandler = useCallback(
    _.debounce(parentSetSearchStr, searchDebounceDelay),
    []
  );
  const debouncedSearchQueryHandler2 = useCallback(
    _.debounce(parentSetSearchStr2, searchDebounceDelay),
    []
  );
  const debouncedSearchQueryHandler3 = useCallback(
    _.debounce(parentSetSearchStr3, searchDebounceDelay),
    []
  );

  useEffect(() => {
    if (parentSearchStr !== searchStr) {
      debouncedSearchQueryHandler(searchStr);
    }
  }, [searchStr]);
  useEffect(() => {
    if (parentSearchStr2 !== searchStr2) {
      debouncedSearchQueryHandler2(searchStr2);
    }
  }, [searchStr2]);
  useEffect(() => {
    if (parentSearchStr3 !== searchStr3) {
      debouncedSearchQueryHandler3(searchStr3);
    }
  }, [searchStr3]);

  const { t } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const onUserSearch = () => {
    onUserSearchClick();
  };

  const userOrgType = getOrgType();


  return (
    <Card style={{ marginBottom: "1rem", border: "none" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "15px",
          "& svg": { m: 1.5 },
          "& hr": { mx: 0.5 },
        }}
      >
        <Grid
          container
          wrap="nowrap"
          sx={{ flexDirection: { xs: "column", md: "row", oveflow: "auto" } }}
          spacing={2}
          justify="flex-start"
        >
          <Grid item xs={9}>
            <h2 className="d-flex">{t("Users.userslist")}</h2>
          </Grid>
          <Grid item xs={3}>
            {HasPermissions(INFO?.AddNewUser?.actionName, PER?.ScreenPermissions?.Insert) &&
              <Button
                sx={{ marginLeft: "170px" }}
                role="primary"
                size="default"
                trailingComponent={<PlusIcon />}
                label="Add New"
                onClick={handleClickOpen}
              />
            }
            <Dialog
              maxWidth={"sm"}
              fullWidth={true}
              open={open}
              onClose={handleClose}
              width="450"
              className="w-100"
            >
              <Adduser close={handleClose} />
            </Dialog>
          </Grid>
        </Grid>
      </Box>

      <Divider
        style={{ height: "1.5px", backgroundColor: "rgb(130 133 137)" }}
      />

      <Box
        className="mt-3"
        style={{ padding: "16px" }}
        sx={{ "& h1": { m: 0 } }}
      >
        <Grid
          container
          wrap="nowrap"
          sx={{ flexDirection: { xs: "column", md: "row", oveflow: "auto" } }}
          spacing={1}
          justify="flex-start"
        >
          <Grid item xs={3}>
            <FormControl
              inputType="text"
              placeholder="First name"
              value={searchStr}
              handleChange={setSearchStr}
              setValidate={() => { }}
            />
          </Grid>
          <Grid item xs={3}>
            <FormControl
              inputType="text"
              placeholder="Last name"
              value={searchStr2}
              handleChange={setSearchStr2}
              setValidate={() => { }}
            />
          </Grid>
          <Grid item xs={3}>
            <FormControl
              inputType="text"
              placeholder="Email"
              value={searchStr3}
              handleChange={setSearchStr3}
              setValidate={() => { }}
            />
          </Grid>
          <Grid item sx={{ margin: "auto" }}>
            <Grid
              container
              wrap="nowrap"

              sx={{
                flexDirection: { xs: "column", md: "row", overflow: "auto" },
                marginLeft: "auto"
              }}
              spacing={1}
            >
              {userOrgType === "Admin" && (
                <Grid item >
                  {/* <Button
                    sx={{ width: "130px" }}
                    role="tertiary"
                    size="large"
                    label="Filters"
                    trailingComponent={<FilterIcon />}
                    onClick={openSlidingPopup}
                  /> */}
                </Grid>
              )}
              <Grid item>
                {/* <Button
                  sx={{ width: "130px" }}
                  role="primary"
                  size="large"
                  label="Search"
                  trailingComponent={<SearchIcon />}
                  onClick={onUserSearch}
                /> */}
                {userOrgType === "Admin" && (
                  <Grid item >
                    <Button
                      sx={{ width: "130px" }}
                      className="ml-3"
                      role="tertiary"
                      size="large"
                      label="Filters"
                      trailingComponent={<FilterIcon />}
                      onClick={openSlidingPopup}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ marginLeft: "auto" }}>
            <ExportToExcel
              url={downloadUrl + "&IsDownloadRequest=" + true}
              filename={fileName}
              sheetname={sheetName}
              headers={headers}
            />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
}
